import React from 'react';
import { useIntl } from 'react-intl';
import './Criteria.scss';

const criterias = ['carbon.form.criterias.first', 'carbon.form.criterias.second', 'carbon.form.criterias.third', 'carbon.form.criterias.four', 'carbon.form.criterias.five', 'carbon.form.criterias.six', 'carbon.form.criterias.seven', 'carbon.form.criterias.eight', 'carbon.form.criterias.nine', 'carbon.form.criterias.ten', 'carbon.form.criterias.eleven', 'carbon.form.criterias.twelve', 'carbon.form.criterias.thirteen'];
const Criteria = ({ isActiveTab }) => {
  const translate = useIntl();
  return (
    <div style={{ display: isActiveTab ? 'block' : 'none' }}>
      <p className="form-field-title">
        {translate.formatMessage({ id: 'carbon.form.criterias.title' })}
      </p>
      <ul className="comments__confirm-list">
        {criterias.map((el) => (
          <li key={el}>
            <span />
            <p>{translate.formatMessage({ id: el })}</p>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Criteria;
